import React from 'react';
import { CloseButtonSvgIcon } from './IconProvider';

const ConfirmationModal = ({
  firstText,
  secondText,
  successBtnText,
  cancelBtnText,
  closeModal,
  functionCall,
}) => {
  return (
    <>
      <div className="flex justify-center  items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none mt-16">
        <div className="relative w-full mx-3 my-4 max-w-md">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white dark:bg-slate-800  dark:text-slate-200 outline-none focus:outline-none">
            {/*header*/}
            <div className="flex justify-between items-center py-3 px-6">
              <div></div>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute right-1 top-3 z-10 flex justify-center items-center"
                onClick={closeModal}
              >
                <span className="bg-transparent text-black w-10 dark:bg-slate-400 dark:rounded-md block outline-none focus:outline-none">
                  <CloseButtonSvgIcon />
                </span>
              </button>
            </div>
            {/*body*/}
            <div className="relative p-8 flex-auto">
              <div className="text-center mb-3"></div>
              <h4 className="text-center mb-2 font-bold mt-6">
                {firstText || 'NA'}
              </h4>
              <div className="text-md text-center  max-w-xs mx-auto">
                {secondText || 'NA'}{' '}
              </div>
            </div>
            {/*footer*/}
            <div className="py-6 px-8 text-center flex gap-6 justify-between">
              <button
                className="bg-white active:bg-[#92C24B] w-full text-brandBlue border border-gray-300 font-bold uppercase text-sm px-6 py-3 rounded-lg inline-block shadow hover:shadow-lg outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={closeModal}
              >
                {cancelBtnText || 'NA'}
              </button>
              <button
                onClick={functionCall}
                className="bg-GreenColor active:bg-[#92C24B] w-full text-brandBlue border border-GreenColor font-bold uppercase text-sm px-6 py-3 rounded-lg  inline-block shadow hover:shadow-lg outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150"
                type="button"
              >
                {successBtnText || 'NA'}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};
export default ConfirmationModal;
